/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Submit_Badge_VerifiedInputs */

const en_directory_submit_badge_verified = /** @type {(inputs: Directory_Submit_Badge_VerifiedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Verified — dofollow unlocked`)
};

const zh_directory_submit_badge_verified = /** @type {(inputs: Directory_Submit_Badge_VerifiedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`已验证，dofollow 已解锁`)
};

/**
* | output |
* | --- |
* | "Verified — dofollow unlocked" |
*
* @param {Directory_Submit_Badge_VerifiedInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_submit_badge_verified = /** @type {((inputs?: Directory_Submit_Badge_VerifiedInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Submit_Badge_VerifiedInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_submit_badge_verified(inputs)
	return zh_directory_submit_badge_verified(inputs)
});
export { directory_submit_badge_verified as "directory.submit.badge_verified" }